module.exports = __webpack_public_path__ + "static/Mutant-c10134c0e1d9c39779a686d2a844fe3c.jpg";